import React from "react";

function Home() {
  return (
    <div id="main">
      <section className="content">
        <div className="PlaceHolder">
          <div className=" OneLine">
            <h1 className="">
              Bibliotheca Iulia Instaurata = Julius II’s Library Renewed……
            </h1>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
